<!-- @format -->

<template>
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col md="5" sm="4" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>Per page</label>
          <v-select v-model="pageSize" :options="pageSizeOptions" :clearable="false" class="per-page-selector d-inline-block ml-50 mr-1" />
        </b-col>

        <!-- Search -->
        <b-col>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input v-if="!memberOnly" v-model="userId" class="d-inline-block mr-1" placeholder="Member ID (optional)" />
            <BFormDatepicker v-model="startTime" class="d-inline-block mr-1" placeholder="Start date (optional)" :reset-button="true" />
            <BFormDatepicker v-model="endTime" class="d-inline-block mr-1" placeholder="End date (optional)" :reset-button="true" />
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
      bordered
      tbody-tr-class="text-center"
      :selectable="selectable"
      select-mode="multi"
      @row-clicked="contentChange"
      ref="orderListTable"
      :items="fetchInvoices"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative text-center"
      style="min-height: 400px"
    >
      <template #cell(moneys)="data">
        <b-link class="font-weight-bold" @click.stop="showDetail(data.item)">
          {{ data.value }}
        </b-link>
      </template>
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination v-model="currentPage" :total-rows="totalInvoices" :per-page="pageSize" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal id="detailModal" title="Details" size="lg" hide-footer>
      <div class="d-flex justify-content-end mb-1">
        <b-button variant="primary" :disabled="!selectedDetailRows.length" @click="downloadModalDetails">
          Download
        </b-button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Policy Number</th>
            <th>Insured</th>
            <th>Paid Commission</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in selectedItem.xiangqing" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.protect_user }}</td>
            <td>{{ item.change_moeny }}</td>
            <td>{{ item.created_at }}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BFormInput, BTable, BPagination, BFormDatepicker, BButton, BLink } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { getCurrentInstance, ref, computed } from '@vue/composition-api'
import 'flatpickr/dist/flatpickr.css'
import useInvoicesList from './useOrderList'
import {
  downloadEarningDetailsCsv,
  mapXiangqingRows,
} from './exportEarningDetails'

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    vSelect,
    BButton,
    BLink,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const memberOnly = !!proxy.$route.meta.memberScope

    const {
      startTime,
      endTime,
      userId,
      fetchInvoices,
      tableColumns,
      pageSize,
      currentPage,
      totalInvoices,
      dataMeta,
      pageSizeOptions,
      orderListTable,
      refetchData,
    } = useInvoicesList(proxy, { memberOnly })

    const selectable = ref(true)
    const selectedItem = ref({})

    const selectedDetailRows = computed(() => mapXiangqingRows(selectedItem.value?.xiangqing))

    const piliangArray = ref([])
    const contentChange = (item, index, event) => {
      if (piliangArray.value.indexOf(item.id) == -1) {
        piliangArray.value.push(item.id)
      } else {
        piliangArray.value.splice(piliangArray.value.indexOf(item.id), 1)
      }
    }

    const showDetail = item => {
      selectedItem.value = item
      proxy.$bvModal.show('detailModal')
    }

    const downloadModalDetails = () => {
      if (!selectedDetailRows.value.length) return
      downloadEarningDetailsCsv(selectedDetailRows.value, 'Earning-Record-Details.csv')
    }

    return {
      memberOnly,
      startTime,
      endTime,
      userId,
      piliangArray,
      contentChange,
      showDetail,
      selectedItem,
      selectedDetailRows,
      downloadModalDetails,
      selectable,
      fetchInvoices,
      tableColumns,
      pageSize,
      currentPage,
      totalInvoices,
      dataMeta,
      pageSizeOptions,
      orderListTable,
      refetchData,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 100px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.wocc {
  >>> .dropdown-toggle {
    padding: 0px !important;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.form-control-time {
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  display: block;
  width: 100%;
  height: 2.714rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.45;
  color: #6e6b7b;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
